import {KMDFSOutro} from "./KMDFSOutro";
import {KennethMustDie} from "../../KennethMustDie";
import {KMDSound} from "../../sound/KMDSound";

export class KMDCFSOutro extends KMDFSOutro {

    constructor() {
        super();
        this.name = "KMDCFSOutro";
    }

    protected getAssetName(): string {
        return ("cfsOutro");
    }

    protected getAnimationTabName(isBelowWinStake: boolean, totalWin: number, playedBetValue: number): string {
        return "animation" + (KennethMustDie.useCensor ? "_blur" : ""); // #477
    }

    protected playOutroSound(): void {
        KennethMustDie.soundPlayer.playSound(KMDSound.CFS_INTRO_IMPACT);

        KennethMustDie.soundPlayer.switchMusic("loaderLoop");
    }

    protected playBtnSound(): void {
        KennethMustDie.soundPlayer.playSound(KMDSound.BTN_OUTRO_CFS);
    }
}